import validate from 'validate.js'

/**
 * Validates createTestimony payload
 * @param {{ title: String, content: String, email: String, name: String }} payload testimony payload
 */
export function validateCreateTestimony (payload) {
  if (!validate.isObject(payload)) {
    throw new TypeError(`Function "createTestimony" expected paylaod of type "object", but got ${typeof payload}`)
  }

  const contraints = {
    title: {
      type: 'string'
    },
    content: {
      type: 'string',
      presence: true
    },
    email: {
      email: true,
      presence: true
    },
    name: {
      type: 'string',
      presence: true
    }
  }

  const invalid = validate(payload, contraints)

  if (invalid) {
    throw new Error(JSON.stringify(invalid))
  }

  return true
}
